import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { isAddressEmpty } from '@utils/address-utils';
import { Subscription } from 'rxjs';
import { finalize, first } from 'rxjs/operators';
import { TimeUnits } from '../../../../utils';

import { Shop } from '../../../services/shops/shop.model';
import { ShopService } from '../../../services/shops/shop.service';
import { Address } from '../../../sharedModule/models/address.model';
import { PdqToastComponent } from '../../../storybook/components/toast/toast.component';
import { ToastService } from '../../../storybook/services/toast/toast.service';
import { LocaitonType } from './location-edit/location-edit.component';

const returnAddressNamePlaceholder = 'Return Address';
@Component({
  selector: 'locations-tab',
  templateUrl: './locations.component.html',
  styleUrls: ['./locations.component.scss'],
  standalone: false,
})
export class LocationsComponent implements OnInit, OnDestroy {
  primaryLocation: Address;
  postReturnAddress: Address;
  additionalLocations: Address[] = [];
  shopSubscription: Subscription;
  syncLoading = false;
  constructor(
    private toastService: ToastService,
    private shopService: ShopService,
    private router: Router,
    private route: ActivatedRoute,
  ) {}
  ngOnDestroy(): void {
    if (this.shopSubscription) {
      this.shopSubscription.unsubscribe();
    }
  }

  ngOnInit(): void {
    this.initShopService();
  }

  initShopService() {
    this.shopSubscription = this.shopService.shop$.subscribe((shop) => {
      this.assignLocations(shop);
    });
  }

  handleSync() {
    this.syncLoading = true;
    this.shopService
      .syncShopLocations()
      .pipe(
        first(),
        finalize(() => (this.syncLoading = false)),
      )
      .subscribe(
        (shop) => {
          this.assignLocations(shop);
          this.toastService.show(PdqToastComponent, {
            mode: 'success',
            message: 'Locations synced',
            duration: TimeUnits._SECOND_IN_MS * 3,
          });
        },
        (err) => {
          console.log(err);
          this.toastService.show(PdqToastComponent, {
            mode: 'danger',
            message: 'Failed to sync locations',
            duration: TimeUnits._SECOND_IN_MS * 3,
          });
        },
      );
  }

  assignLocations(shop: Shop) {
    this.primaryLocation = shop.shopLocations?.find((location) => location.isPrimaryLocation);
    this.additionalLocations = shop.shopLocations
      ?.filter((location) => location.id !== this.primaryLocation?.id)
      ?.sort((a, b) => a.id - b.id);
    this.postReturnAddress = isAddressEmpty(shop.postOfficeReturn) ? this.postReturnAddress : shop.postOfficeReturn;
    if (!this.postReturnAddress?.storeName) {
      this.postReturnAddress = { storeName: returnAddressNamePlaceholder } as Address;
    }
  }
  handleLocationClick(id: number) {
    let redirectId;
    if (id === this.primaryLocation?.id) redirectId = LocaitonType.PRIMARY;
    else if (id === this.postReturnAddress?.id) redirectId = LocaitonType.POST_RETURN;
    else redirectId = id;
    this.router.navigate(['./edit-location', `${redirectId}`], {
      relativeTo: this.route,
      state: { editable: redirectId === LocaitonType.POST_RETURN ? true : false },
    });
  }
}
